import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'

import { ServerValidationError } from '@/api/shared/types'

import { ParkingService } from '../lib/parking.service'
import { AutoDTO, CreateAutoResponse } from '../lib/parking.types'
import { GET_AUTOS } from './useAutos'

export const useCreateAuto = () => {
  const queryClient = useQueryClient()

  return useMutation<
    AxiosResponse<CreateAutoResponse>,
    AxiosError<ServerValidationError>,
    AutoDTO
  >({
    mutationFn: params => ParkingService.createAuto(params),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [GET_AUTOS] })
  })
}
